var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNavigateArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1191_7356",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.183594,
    width: 30,
    height: 30,
    fill: "#F5F5F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1191_7356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6463 15.1825L10 7.53624L11.1769 6.35938L20 15.1825L11.1769 24.0057L10 22.8288L17.6463 15.1825Z",
    fill: "#BDBDBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavigateArrow);
export default __webpack_public_path__ + "static/media/icon_navigate_arrow.65c0a8f665912fa1f5354f87b9f28a7a.svg";
export { ForwardRef as ReactComponent };